import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  CampaignUmbrellaChildStateType,
  SetFormPayloadActualType,
  SetOptionPayloadActualType,
  SetBulkUploadPayloadActualType,
  SetPopupPayloadActualType,
} from 'features/CampaignAndDiscount/@types/campaignUmbrellaChild'

export const SLICE_NAME = 'campaignUmbrellaChild'

export enum CampaignCriteriaEnum {
  RAFAKSI_BMSM = 'Rafaksi BMSM v2',
  FLASH_SALE = 'Flash Sale',
  RAFAKSI = 'Rafaksi',
}

export const PromoCriteriaBMSM = { name: 'Rafaksi BMSM', id: CampaignCriteriaEnum.RAFAKSI_BMSM }
export const PromoCriteriaFlashSale = { name: 'Flash Sale', id: CampaignCriteriaEnum.FLASH_SALE }
export const PromoCriteriaRafaksi = { name: 'Rafaksi', id: CampaignCriteriaEnum.RAFAKSI }

export const initialState: CampaignUmbrellaChildStateType = {
  isLoading: false,
  form: {
    campaignName: '',
    campaignCluster: {
      name: '',
      id: '',
    },
    vendor: {
      id: '',
      name: '',
    },
    criteria: {
      id: '',
      name: '', // default value, can be changed later
    },
    brand: {
      id: '',
      name: '',
    },
    startDate: '', // ISO string or RFC3339
    endDate: '', // ISO string or RFC3339
    startTime: '', // ISO string or RFC3339
    endTime: '', // ISO string or RFC3339
    reimbursement: {
      method: 'Transfer',
      number: '',
      name: 'Transfer',
    },
    skp_no: '',
    status: '',
    catmanFeedbackUrl: null,
    submission_status: '',
    is_topup: false,
    is_budget_internal: false,
  },
  option: {
    vendor: [],
    campaignCluster: [],
    criteria: [PromoCriteriaBMSM, PromoCriteriaFlashSale, PromoCriteriaRafaksi],
    brand: [],
  },
  productSKP: {
    isLoading: false,
    data: [],
    query: { name: '', offset: 0, limit: 20, isQuerySearchable: false, isInitialFetch: true },
  },
  bulkUpload: {
    bulkUploadUrl: '',
    templateUrl: '',
    name: '',
    id: 0,
    code: 'SKP_CAMPAIGN_PLAN_SINGLE_DISCOUNT',
  },
  popup: { mode: '' },
}

const campaignUmbrellaChild = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setForm: (state, action: PayloadAction<SetFormPayloadActualType>) => {
      state.form = {
        ...state.form,
        ...action.payload,
      }
    },
    setOption: (state, action: PayloadAction<SetOptionPayloadActualType>) => {
      state.option = {
        ...state.option,
        ...action.payload,
      }
    },
    setProductSKP: (
      state,
      action: PayloadAction<Partial<CampaignUmbrellaChildStateType['productSKP']>>,
    ) => {
      state.productSKP = {
        ...state.productSKP,
        ...action.payload,
      }
    },
    setProductSKPQuery: (
      state,
      action: PayloadAction<Partial<CampaignUmbrellaChildStateType['productSKP']['query']>>,
    ) => {
      state.productSKP.query = {
        ...state.productSKP.query,
        ...action.payload,
      }
    },

    setBulkUpload: (state, action: PayloadAction<SetBulkUploadPayloadActualType>) => {
      state.bulkUpload = {
        ...state.bulkUpload,
        ...action.payload,
      }
    },
    setPopup: (state, action: PayloadAction<SetPopupPayloadActualType>) => {
      state.popup = {
        ...state.popup,
        ...action.payload,
      }
    },
  },
})

export const {
  setIsLoading,
  reset,
  setForm,
  setOption,
  setProductSKP,
  setBulkUpload,
  setProductSKPQuery,
  setPopup,
} = campaignUmbrellaChild.actions
export default campaignUmbrellaChild.reducer
